import { SET_QR_CODE_URL } from '@/constants';

export const setQrCodeURL = (imageURL) => ({
    type: SET_QR_CODE_URL,
    imageURL
});
